module.exports = __webpack_public_path__ + "static/media/pass-generate.03257e10.svg";